<div class="toaster radius_xs">
    <div class="w-100">
        <div class="toast-details gap-2 align-items-center">
            <div class="toast-badge width-2 height-72 radius_md"></div>
            <berry-icon class="ph-3" [name]="iconName" [color]="iconColor" [size]="45">
            </berry-icon>
            <div [class]="options.titleClass + ' flex-1'">
                <berry-typo *ngIf="!title" [name]="'body2'" [weight]="700">
                    {{ 'Warning_CorrespondenceNew' | translate }}
                 </berry-typo>
                <berry-typo [weight]="700" [name]="'body2'" *ngIf="!!title">{{ title | translate }}</berry-typo>
                <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite" class="custom-message"
                     [class]="options.messageClass" [innerHTML]="message"></div>
                <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite" class="custom-message"
                     [class]="options.messageClass" [attr.aria-label]="message">
                    <berry-typo [name]="'body2'" [color]="'secondary'" [weight]="500">
                        {{message | translate}}
                    </berry-typo>
                </div>
                <div class="actions-container gap-2">
                    <ng-container *ngFor="let action of actions; let i = index">
                        <berry-button [data-automation-id]="getAutomationId(i)"
                                      [label]="action.label | translate" [size]="action.size"
                                      [style]="action.style" (click)="action.event()">
                        </berry-button>
                    </ng-container>
                </div>
            </div>
            <div style="align-self: flex-start">
                <berry-icon [name]="'close'" color ="muted" [size]="20">
                </berry-icon>
            </div>
        </div>

    </div>
</div>
